import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useGetUserQuery,
  useUpdateNotificationMutation,
} from "../../../../store/auth/usersApiSlice";
import { NotificationPanel } from "./NotificationPanel";

/* The notifications drawer, wired up. */
export const NotificationDrawer = ({ open = false, onClose = () => {} }) => {
  const { userInfo, token } = useSelector((state) => state.auth);
  const [items, setItems] = useState([]);
  const { refetch } = useGetUserQuery(token);
  const [updateNotification] = useUpdateNotificationMutation();

  useEffect(() => {
    setItems(userInfo?.notifications || []);
  }, [userInfo?.notifications]);

  /* Transcribed, including the rollback: a failed write must not leave a row
     looking read when the server still has it unread. */
  const handleSelect = async (notification) => {
    const notificationId = notification?.id;
    if (!notificationId || notification?.is_read) return;

    const previous = items;
    setItems(items.map((n) => (n.id === notificationId ? { ...n, is_read: true } : n)));
    try {
      const response = await updateNotification({ notificationId, token }).unwrap();
      if (response) refetch();
    } catch (err) {
      console.error("Failed to update notification:", err);
      setItems(previous);
    }
  };

  return (
    <NotificationPanel
      open={open}
      notifications={items}
      onClose={onClose}
      onSelect={handleSelect}
    />
  );
};

export default NotificationDrawer;
